import { Component, computed, inject } from '@angular/core';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { NfPipe } from '../../../pipes/nf.pipe';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';

@Component({
  selector: 'btlib-order-amount-summary',
  standalone: true,
  imports: [LibModulesWolcModule, NfPipe],
  templateUrl: './order-amount-summary.component.html',
  styleUrl: './order-amount-summary.component.scss'
})
export class BtOrderAmountSummaryComponent {
  state = inject(CartItemStateService);

  amount = this.state.amount;
  loading = this.state.loading;
  totalAmount = this.state.totalAmount;
  isOrderable = this.state.isOrderable;

  hasDiscount = computed(() => {
    const a = this.amount();
    return !!a && a.retailAmount > 0 && a.amount < a.retailAmount;
  });

  discountAmount = computed(() => {
    const a = this.amount();
    if (!a) return 0;
    return -(a.retailAmount - a.amount);
  });
}
